import $ from 'jquery'
import { trace } from 'rytm-helpers'
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"

let list = []

const initMasonryElement = (el, index) => {
  // trace("init masonry", el)
  const params = {
    itemSelector: '.masonry-item',
    columnWidth: '.masonry-item'
  }
  let msnry = new Masonry(el, params)
  list.push(msnry)
  let il = imagesLoaded(el)
  il.on('done', () => {
    msnry.layout()
  })
}

const destroyMasonryElement = (msnry, index) => {
  // trace("destroy masonry", msnry)
  msnry.destroy()
}

export const destroyMasonry = () => {
  list.forEach(destroyMasonryElement)
  list = []
}
export const buildMasonry = () => {
  const list = [...document.querySelectorAll(".cdz-masonry")]
  list.forEach(initMasonryElement)
}